import {
  Component,
  NgZone,
  OnInit,
  ViewEncapsulation,
  Input,
  AfterViewInit,
  EventEmitter,
  ViewChild,
} from "@angular/core";

import { Location } from "@angular/common";
import { Router, Event, NavigationError, NavigationCancel, NavigationEnd } from "@angular/router";
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, from } from "rxjs";
import * as localforage from "localforage";
import { DattaConfig } from "src/app/config/app-config";
import { IConfigPage,
  ModuleTypes,
  PageTypes,
  EntryTypes,
  IItem,
  IMultiProperties, } from "src/app/metadata/interfaces/page/Pages";
import { SkyaccessApp } from "src/app/services/skyaccessconfig/skyaccess-app.service";
import { skyaccessData } from "src/app/services/skyaccessconfig/skyaccess-data";
import { UtilityService } from "src/app/services/skyaccessconfig/utility.service";
import { FullScreenToggleService } from "src/app/services/core/full-screen-toggle.service";
import { SkyAccess_IFrame } from "src/app/enums/skyaccess/iframe";

@Component({
  selector: "app-configuration",
  templateUrl: "./configuration.component.html",
  styleUrls: ["./configuration.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ConfigurationComponent implements OnInit, AfterViewInit {
  public styleSelectorToggle: boolean; // open configuration menu
  public layoutType: string; // layout type
  public rtlLayout: any; // rtl type
  public menuFixedLayout: any; // menu/navbar fixed flag
  public headerFixedLayout: any; // header fixed flag
  public boxLayout: any; // box layout flag
  public isColoredIcon: any; // menu icon color
  public headerBackgroundColor: string; // header background color
  public navbarBackgroundColor: string; // navbar background color
  public brandBackgroundColor: string; // brand/logo background color
  public navBackgorundImage: any; // navbar background image

  public menuDropdownIcon: string; // navbar background image
  public menuListIcon: string; // navbar background image

  public navActiveColor: string;
  public navTitleColor: string;
  public menuTitleHide: any;

  public headerBackColor: string;

  public dattaConfig: any;
  public isConfig: boolean;
  @Input() IsSkyaccessApp: boolean = false;
  public ConfigPage: IConfigPage;
  public GnSetting: IItem[];
  public ModuleList: IItem[];
  public ModuleList2: IItem[];
  public Properties: IMultiProperties[];
  public ConfigSaved: boolean;
  public ConfigSaveFailed: boolean;

  isLoaded: boolean = false;
  onInitCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  isRouteOnConfigurator = false;
  
  loadSkyAccess_DB: LocalForage;

  @ViewChild('configTabset', { static: false, read: NgbTabset}) configTabsetRef: NgbTabset; 

  constructor(
    private zone: NgZone,
    private location: Location,
    private router: Router,
    private skyAcceAp: SkyaccessApp,
    public utilityService: UtilityService,
    private fullscreenToggleService: FullScreenToggleService
  ) {
    
    /**
     * Subscribe to Router Events and only permit SkyAccess Configuration Tab to be accessible
     * when current route is on 'SkyAccess Hotel Customizer'
     */
    
    this.router.events.subscribe((routerEvent: Event) => {

      if (routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationError ||
        routerEvent instanceof NavigationCancel) {
          if(routerEvent.url.toLowerCase().includes('/skyaccess/hotel')) this.isRouteOnConfigurator = true;
          else {
            this.configTabsetRef?.select('cloud-app-tab');
            this.isRouteOnConfigurator = false;
          }
        }
    })
  }

  ngOnInit() {
    this.fullscreenToggleService.fullScreenEmitter.subscribe(event => {
      let currentTheme = localStorage.theme;
      if (currentTheme !== "menu-light") {
        this.SetIntThemes('dark');
      } else {
        this.SetIntThemes('menu-light');
      }
    });
    let count = 0;
    let apiEmitter = new EventEmitter<boolean>();
    apiEmitter.subscribe(value => {
      count++;
      if (count >= 2) {
        count = 0;
        this.onInitCompleted.emit(true);
      }
    });
    const initializer = () => {
      this.ConfigSaved = false;
      this.ConfigSaveFailed = false;

      

      this.GnSetting = this.utilityService.GnSetting;
      // this.ConfigPage = this.skyAcceAp._ConfigPage;
      this.ModuleList = this.utilityService.ModuleList_1;
      this.ModuleList2 = this.utilityService.ModuleList_2;
      this.Properties = this.utilityService.Properties;

      this.ConfigPage = this.utilityService.ConfigPage;

      (this.ConfigPage);

      this.isLoaded = true;
    }

    this.loadSkyAccess_DB = localforage.createInstance({
      name: "data_cache",
      storeName: "skyAccess"
    });

    this.utilityService.onInitEmitter.subscribe(emittedValue => {
      initializer();
    });
    this.utilityService.OnInit();
    
    // this.loadSkyAccess_DB.getItem("skyList").then(skyAccessData => {
    //   (skyAccessData);
    //   if(Array.isArray(skyAccessData)){
    //     this.skyAcceAp.setAllPages(skyAccessData);
    //   }
    //   this.utilityService.onInitEmitter.subscribe(emittedValue => {
    //     initializer();
    //   });
    //   this.utilityService.OnInit();
    // }, err => {
    //   this.utilityService.onInitEmitter.subscribe(emittedValue => {
    //     initializer();
    //   });
    //   this.utilityService.OnInit();
    // });
    
    let currentTheme = localStorage.theme;

    try {
      this.modifyIgxTheme("igx-dark-theme");

      if (!this.IsSkyaccessApp) this.dattaConfig = DattaConfig.config;
      // else
      //   this.dattaConfig = DattaConfig.configApp;

      this.setThemeLayout();

      this.styleSelectorToggle = false;

      this.layoutType = this.dattaConfig["layout-type"];
      this.setLayout(this.layoutType);

      this.isColoredIcon = this.dattaConfig["nav-icon-color"];
      this.changeIconColor(this.isColoredIcon);

      this.headerBackgroundColor = this.dattaConfig["header-back-color"];
      this.navbarBackgroundColor = this.dattaConfig["nav-back-color"];
      this.brandBackgroundColor = this.dattaConfig["nav-brand-color"];
      this.navBackgorundImage = this.dattaConfig["nav-back-image"];

      this.setHeaderBackground(this.headerBackgroundColor);
      this.setNavbarBackground(this.navbarBackgroundColor);
      this.setBrandBackground(this.brandBackgroundColor);
      this.setBackgroundImage(this.navBackgorundImage);

      this.rtlLayout = this.dattaConfig["rtl-layout"];
      this.changeRtlLayout(this.rtlLayout);

      this.menuFixedLayout = this.dattaConfig["nav-fixed-layout"];
      if (this.dattaConfig["layout"] === "vertical") {
        this.changeMenuFixedLayout(this.menuFixedLayout);
      }

      this.headerFixedLayout = this.dattaConfig["header-fixed-layout"];
      this.changeHeaderFixedLayout(this.headerFixedLayout);

      this.boxLayout = this.dattaConfig["box-layout"];
      this.changeBoxLayout(this.boxLayout);

      this.menuDropdownIcon = this.dattaConfig["nav-dropdown-icon"];
      this.setMenuDropdownIcon(this.menuDropdownIcon);

      this.menuListIcon = this.dattaConfig["nav-list-icon"];
      this.setMenuListIcon(this.menuListIcon);

      this.navActiveColor = this.dattaConfig["nav-active-list-color"];
      this.setNavActiveColor(this.navActiveColor);

      this.navTitleColor = this.dattaConfig["nav-list-title-color"];
      this.setNavTitleColor(this.navTitleColor);

      this.menuTitleHide = this.dattaConfig["nav-list-title-hide"];
      this.changeMenuTitle(this.menuTitleHide);

      if (
        this.dattaConfig["pre-layout"] !== "" &&
        this.dattaConfig["pre-layout"] !== null
      ) {
        this.setPreBuildLayout(this.dattaConfig["pre-layout"]);
      }
      // this.router.navigate(['/dashboard/default']);
      if (!this.IsSkyaccessApp) {
        this.setHeaderBackColor("#424448");
        (document.querySelector(
          ".pcoded-header"
        ) as HTMLElement).style.background = "#424448";

        this.changeMenuFixedLayout(false);
        if (currentTheme !== "menu-light") {
          this.SetIntThemes('dark');
        } else {
          this.SetIntThemes('menu-light');
        }
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, ngoninit :" + ex.message);
    }
  }

  ngAfterViewInit() {
    this.onInitCompleted.subscribe((value) => {
      
    });
  }

  modifyIgxTheme(value: string) {
    /**
     * Previous Implementation commented out
     */
    /* 

    // Retrieve all css variables from root and filter the needed igniteui variables for the array
    let myArray = Array.from(document.styleSheets)
      .filter(
        (sheet) =>
          sheet.href === null || sheet.href.startsWith(window.location.origin)
      )
      .reduce(
        (acc, sheet) =>
          (acc = [
            ...acc,
            ...Array.from(sheet.cssRules).reduce(
              (def, rule) =>
                (def =
                  (rule as any).selectorText === ":root"
                    ? [
                        ...def,
                        ...Array.from((rule as any).style).filter((name: any) =>
                          name.startsWith("--igx") 
                          && ((name as string).endsWith("text-color") || (name as string).includes("content-background"))
                          && !(name as string).includes("hover")
                          && !(name as string).includes("border")
                          && !(name as string).includes("outlined")
                          && !(name as string).includes("dropdown")
                          && !(name as string).includes("checkbox")
                        ),
                      ]
                    : def),
              []
            ),
          ]),
        []
      );

  
  
      // Change color according to theme
      myArray.forEach((variable: string) => {
        if (variable.includes('background')) {
          document.documentElement.style.setProperty(variable, 'transparent');
        } else {
          document.documentElement.style.setProperty(variable, value);
        }
      });
 */

    //remove the current theme

    document.body.classList.remove(
      value === "igx-light-theme" ? "igx-dark-theme" : "igx-light-theme"
    );

    //new grant the laundry theme in the

    document.body.classList.add(
      value !== "igx-light-theme" ? "igx-dark-theme" : "igx-light-theme"
    );
  }

  ToggleMenu(): void {
    try {
      this.styleSelectorToggle = !this.styleSelectorToggle;
      if (!this.styleSelectorToggle) {
        // (document.querySelector(".toggleConfig") as HTMLElement).style.transition = 'width 2s linear 1s';
        // (document.querySelector(".toggleConfig") as HTMLElement).style.transitionTimingFunction = '2s';
        // (document.querySelector(".toggleConfig") as HTMLElement).style.tra = '2s';
        document.querySelectorAll(".toggleConfig").forEach((t) => {
          (t as HTMLElement).style.display = "block";
        });
      } else {
        document.querySelectorAll(".toggleConfig").forEach((t) => {
          (t as HTMLElement).style.display = "none";
        });
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, ToggleMenu :" + ex.message);
    }
  }

  DisplayStatusMsg(data: any): void {
    if (data == true) this.ConfigSaved = true;
    else this.ConfigSaveFailed = true;

    setTimeout(() => {
      this.ConfigSaved = false;
      this.ConfigSaveFailed = false;
    }, 3000);
  }

  SaveConfgChanges(): void {
    this.skyAcceAp.SaveConfigSettings(this.ConfigPage, null).subscribe(value => {
  
  
  this.ConfigSaved = true;
  setTimeout(() => {
    this.ConfigSaved = false;
  }, 3000);
    });
    
  }

  SetSAColor(Id: string, col: any) {
    try {
      this.utilityService.skyAccessTab.select("TabGn");
      let IframesDoc = (document.getElementById(SkyAccess_IFrame.GENERAL_SETTINGS) as HTMLIFrameElement)
        .contentWindow.document;

      if (Id == "MainMenuColor" || Id == "MainMenuBgColor" || Id == "MmFixed") {
        if (
          !IframesDoc.querySelector(".pcoded-navbar").classList.contains(
            "mob-open"
          )
        )
          IframesDoc.querySelector(".pcoded-navbar").classList.add("mob-open");

        IframesDoc.querySelectorAll(
          ".nav-item.pcoded-hasmenu"
        )[1].classList.remove("pcoded-trigger");
        IframesDoc.querySelectorAll(
          ".nav-item.pcoded-hasmenu"
        )[2].classList.remove("pcoded-trigger");
        IframesDoc.querySelectorAll(
          ".nav-item.pcoded-hasmenu"
        )[1].classList.add("pcoded-trigger");
      }

      switch (Id) {
        /* ---------------------------------------------------------- Header menu -------------------------------- */
        case "HeaderColor":
          IframesDoc.querySelectorAll(".b-title").forEach((c) => {
            (c as HTMLElement).style.color = col;
          });
          IframesDoc.querySelectorAll(".mobile-menu").forEach((c) => {
            (c as HTMLElement).style.color = col;
          });
          break;
        case "HeaderBgColor":
          (IframesDoc.querySelector(
            ".navbar.pcoded-header"
          ) as HTMLElement).style.background = col;
          break;
        case "ShowHeaderIcon":
          if (!col.target.checked)
            IframesDoc.querySelectorAll(".b-bgWhite").forEach((c) => {
              (c as HTMLElement).style.display = "none";
            });
          else
            IframesDoc.querySelectorAll(".b-bgWhite").forEach((c) => {
              (c as HTMLElement).style.display = "block";
            });
          break;
        case "HeaderTitle":
          IframesDoc.querySelectorAll(".b-title").forEach((c) => {
            (c as HTMLElement).innerHTML = col;
          });
          break;
        case "HeaderFixed":
          if (col.target.checked)
            IframesDoc.querySelector(".pcoded-header").classList.add(
              "headerpos-fixed"
            );
          else
            IframesDoc.querySelector(".pcoded-header").classList.remove(
              "headerpos-fixed"
            );
          break;

        /* ---------------------------------------------------------- Main menu -------------------------------- */
        case "MainMenuColor":
          IframesDoc.querySelectorAll(
            ".nav.pcoded-inner-navbar .pcoded-mtext"
          ).forEach((c) => {
            (c as HTMLElement).style.color = col;
          });
          IframesDoc.querySelectorAll(
            ".nav.pcoded-inner-navbar .pcoded-submenu li a"
          ).forEach((c) => {
            (c as HTMLElement).style.color = col;
          });

          IframesDoc.querySelectorAll(
            ".pcoded-micon .feather, .pcoded-micon .fa "
          ).forEach((c) => {
            (c as HTMLElement).style.color = col;
          });

          break;

        case "MainMenuBgColor":
          IframesDoc.querySelectorAll(".pcoded-navbar").forEach((c) => {
            (c as HTMLElement).style.background = col;
          });
          break;

        case "MmFixed":
          /* use the setimout() to resize the when the window change */
          if (col.target.checked) {
            IframesDoc.querySelector(".pcoded-navbar").classList.remove(
              "menupos-static"
            );
            (IframesDoc.querySelector(
              "#nav-ps-datta"
            ) as HTMLElement).style.maxHeight = "calc(100vh - 70px)";
          } else {
            IframesDoc.querySelector(".pcoded-navbar").classList.add(
              "menupos-static"
            );
            (IframesDoc.querySelector(
              "#nav-ps-datta"
            ) as HTMLElement).style.maxHeight = "100%";
          }
          break;

        /* ---------------------------------------------------------- Key menu -------------------------------- */
        case "KmColor":
          //  (IframesDoc.querySelector('#ss_menu > .menu .share .bar') as HTMLElement).style.background = col;
          //  let style = IframesDoc.createElement('style');
          //  style.innerHTML = '#ss_menu > .menu .share .bar::before {background:' + col + ' !important;}';
          //  IframesDoc.querySelector('head').appendChild(style);
          //  IframesDoc.querySelectorAll('#ss_menu > .ss_sub_menu i').forEach( c => { (c as HTMLElement).style.color = col });

          if (
            (IframesDoc.querySelector(".keyIcon") as HTMLElement) !=
              undefined &&
            (IframesDoc.querySelector(".keyIcon") as HTMLElement) != null
          )
            (IframesDoc.querySelector(
              ".keyIcon"
            ) as HTMLElement).style.color = col;
          break;

        case "KmBgColor":
          if (
            (IframesDoc.querySelector("#ss_menu > .menu") as HTMLElement) !=
              undefined &&
            (IframesDoc.querySelector("#ss_menu > .menu") as HTMLElement) !=
              null
          )
            (IframesDoc.querySelector(
              "#ss_menu > .menu"
            ) as HTMLElement).style.background = col;

          if (
            (IframesDoc.querySelector(
              "#ss_menu > .ss_sub_menu"
            ) as HTMLElement) != undefined &&
            (IframesDoc.querySelector(
              "#ss_menu > .ss_sub_menu"
            ) as HTMLElement) != null
          )
            IframesDoc.querySelectorAll("#ss_menu > .ss_sub_menu ").forEach(
              (c) => {
                (c as HTMLElement).style.background = col;
              }
            );

          break;
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, SetSAColor :" + ex.message);
    }
  }

  setThemeLayout() {
    try {
      let current_url = this.location.path();
      if (this.location["_baseHref"]) {
        current_url = this.location["_baseHref"] + this.location.path();
      }

      switch (current_url) {
        case this.location["_baseHref"] + "/layout/static":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["nav-fixed-layout"] = false;
          this.dattaConfig["header-fixed-layout"] = false;
          break;
        case this.location["_baseHref"] + "/layout/fixed":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["nav-fixed-layout"] = true;
          this.dattaConfig["header-fixed-layout"] = true;
          break;
        case this.location["_baseHref"] + "/layout/nav-fixed":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["nav-fixed-layout"] = true;
          this.dattaConfig["header-fixed-layout"] = false;
          break;
        case this.location["_baseHref"] + "/layout/nav-image":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["nav-back-image"] = "navbar-image-3";
          break;
        case this.location["_baseHref"] + "/layout/collapse-menu":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["collapse-menu"] = true;
          break;
        case this.location["_baseHref"] + "/layout/horizontal":
          this.dattaConfig["layout"] = "horizontal";
          break;
        case this.location["_baseHref"] + "/layout/box":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["box-layout"] = true;
          this.dattaConfig["collapse-menu"] = true;
          break;
        case this.location["_baseHref"] + "/layout/rtl":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["rtl-layout"] = true;
          break;
        case this.location["_baseHref"] + "/layout/light":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["layout-type"] = "menu-light";
          break;
        case this.location["_baseHref"] + "/layout/dark":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["layout-type"] = "dark";
          this.dattaConfig["nav-back-color"] = "navbar-dark";
          this.dattaConfig["nav-brand-color"] = "brand-dark";
          break;
        case this.location["_baseHref"] + "/layout/icon-color":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["layout-type"] = "menu-light";
          this.dattaConfig["nav-icon-color"] = true;
          break;
        case this.location["_baseHref"] + "/layout/layout-2":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-2";
          break;
        case this.location["_baseHref"] + "/layout/layout-2-2":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-2-2";
          break;
        case this.location["_baseHref"] + "/layout/layout-3":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-3";
          break;
        case this.location["_baseHref"] + "/layout/layout-4":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-4";
          break;
        case this.location["_baseHref"] + "/layout/layout-4-2":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-4-2";
          break;
        case this.location["_baseHref"] + "/layout/layout-5h":
          this.dattaConfig["layout"] = "horizontal";
          this.dattaConfig["layout-type"] = "menu-light";
          this.dattaConfig["nav-icon-color"] = true;
          this.dattaConfig["header-back-color"] = "header-blue";
          break;
        case this.location["_baseHref"] + "/layout/nav-color":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["layout-type"] = "menu-light";
          this.dattaConfig["nav-icon-color"] = true;
          this.dattaConfig["header-back-color"] = "header-lightblue";
          this.dattaConfig["nav-brand-color"] = "brand-lightblue";
          this.dattaConfig["nav-fixed-layout"] = true;
          this.dattaConfig["header-fixed-layout"] = true;
          break;
        case this.location["_baseHref"] + "/layout/layout-6":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-6";
          this.dattaConfig["layout-type"] = "menu-light";
          this.dattaConfig["nav-icon-color"] = true;
          this.dattaConfig["nav-brand-color"] = "brand-lightblue";
          this.dattaConfig["nav-fixed-layout"] = false;
          this.dattaConfig["header-fixed-layout"] = false;
          this.dattaConfig["layout-6-background"] = "#23b7e5";
          break;
        case this.location["_baseHref"] + "/layout/layout-8":
          this.dattaConfig["layout"] = "vertical";
          this.dattaConfig["pre-layout"] = "layout-8";
          this.dattaConfig["layout-type"] = "menu-light";
          this.dattaConfig["header-back-color"] = "header-lightblue";
          this.dattaConfig["nav-brand-color"] = "brand-lightblue";
          this.dattaConfig["nav-fixed-layout"] = true;
          this.dattaConfig["header-fixed-layout"] = true;
          this.dattaConfig["nav-active-list-color"] = "active-lightblue";
          break;
        default:
          break;
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setThemeLayout :" + ex.message);
    }
  }

  setPreBuildLayout(pre_layout) {
    try {
      if (pre_layout === "layout-6") {
        document
          .querySelector(".pcoded-navbar")
          .classList.add("menupos-static");
        this.headerBackColor = this.dattaConfig["layout-6-background"];
        this.setHeaderBackColor(this.headerBackColor);
      }

      if (pre_layout !== "layout-6" && pre_layout !== "layout-8") {
        this.isConfig = false;
        document.querySelector(".pcoded-navbar").classList.add(pre_layout);
      } else {
        document.querySelector("body").classList.add(pre_layout);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setPreBuildLayout :" + ex.message);
    }
  }

  setHeaderBackColor(color) {
    try {
      this.headerBackColor = color;
      (document.querySelector("body") as HTMLElement).style.background = color;
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setHeaderBackColor :" + ex.message);
    }
  }

  SetDarkTheme(): void {
    try {
      this.setNavbarBackground("navbar-dark");
      this.setBrandBackground("navbar-dark");

      document.querySelector(".pcoded-navbar").classList.remove("menu-light");
      document.querySelector(".pcoded-navbar").classList.remove("menu-dark");
      document.querySelector(".pcoded-navbar").classList.remove("navbar-dark");
      document.querySelector(".pcoded-navbar").classList.remove("brand-dark");
      document.querySelector("body").classList.remove("datta-dark");
      this.setHeaderBackground("header-default");

      document.querySelector(".pcoded-navbar").classList.add("navbar-dark");
      document.querySelector(".pcoded-navbar").classList.add("brand-dark");
      this.setNavbarBackground("navbar-dark");
      this.setBrandBackground("brand-dark");
      this.setHeaderBackground("header-default");
      document.querySelector("body").classList.add("datta-dark");

      document.querySelector(".b-title").classList.remove("ColorBlack");
      document.querySelector(".b-title").classList.add("ColorWhite");

      this.setHeaderBackColor("#424448");
      (document.querySelector(
        ".pcoded-header"
      ) as HTMLElement).style.background = "#424448";

      document.querySelector(".b-title").classList.remove("ColorBlack");
      document.querySelector(".b-title").classList.add("ColorWhite");

      document.querySelector(".mobile-menu").classList.remove("ColorBlack");
      document.querySelector(".mobile-menu").classList.add("ColorWhite");

      document.querySelectorAll(".headerCol").forEach((c) => {
        c.classList.remove("ColorBlack");
      });
      document.querySelectorAll(".headerCol").forEach((c) => {
        c.classList.add("ColorWhite");
      });

      // document.querySelectorAll('.headerCol').forEach( c=> {c.removeAttribute("style");});
      // document.querySelectorAll('.headerCol').forEach( c=> {c.setAttribute("style", "color:white;") });
    } catch (ex) {
      this.skyAcceAp.LogEx("config, SetDarkTheme :" + ex.message);
    }
  }

  SetLightTheme(): void {
    try {
      this.setNavbarBackground("navbar-default");
      this.setBrandBackground("brand-default");

      document.querySelector(".pcoded-navbar").classList.remove("menu-light");
      document.querySelector(".pcoded-navbar").classList.remove("menu-dark");
      document.querySelector(".pcoded-navbar").classList.remove("navbar-dark");
      document.querySelector(".pcoded-navbar").classList.remove("brand-dark");
      document.querySelector("body").classList.remove("datta-dark");
      this.setHeaderBackground("header-default");

      document.querySelector(".pcoded-navbar").classList.add("navbar-default");
      document.querySelector(".pcoded-navbar").classList.add("brand-default");
      this.setNavbarBackground("navbar-default");
      this.setBrandBackground("brand-default");
      this.setHeaderBackground("header-default");
      document.querySelector("body").classList.add("menu-light");
      document.querySelector(".pcoded-navbar").classList.add("menu-light");

      //dfe6f5, f6f8fa, 9a9b9c
      this.setHeaderBackColor("#fff");
      (document.querySelector(
        ".pcoded-header"
      ) as HTMLElement).style.background = "#fff";

      document.querySelector(".b-title").classList.remove("ColorWhite");
      document.querySelector(".b-title").classList.add("ColorBlack");

      document.querySelector(".mobile-menu").classList.remove("ColorWhite");
      document.querySelector(".mobile-menu").classList.add("ColorBlack");

      document.querySelectorAll(".headerCol").forEach((c) => {
        c.classList.remove("ColorWhite");
      });
      document.querySelectorAll(".headerCol").forEach((c) => {
        c.classList.add("ColorBlack");
      });

      // document.querySelectorAll('.headerCol').forEach( c=> {c.removeAttribute("style");});
      // document.querySelectorAll('.headerCol').forEach( c=> {c.setAttribute("style", "color:black;") });
    } catch (ex) {
      this.skyAcceAp.LogEx("config, SetLightTheme :" + ex.message);
    }
  }

  SetIntThemes(Theme: string): void {
    localStorage.theme = Theme;
    try {
      this.modifyIgxTheme(
        Theme === "dark" ? "igx-dark-theme" : "igx-light-theme"
      );
      this.isConfig = true;
      this.layoutType = Theme;
      this.dattaConfig["layout-type"] = this.layoutType;
      if (Theme === "dark") this.SetDarkTheme();
      else this.SetLightTheme();
    } catch (ex) {
      this.skyAcceAp.LogEx("config, SetIntThemes :" + ex.message);
    }
  }

  // change main layout
  setLayout(layout) {
    try {
      this.isConfig = true;
      this.setNavbarBackground(this.dattaConfig["nav-back-color"]);
      this.setBrandBackground(this.dattaConfig["nav-brand-color"]);
      document.querySelector(".pcoded-navbar").classList.remove("menu-light");
      document.querySelector(".pcoded-navbar").classList.remove("menu-dark");
      document.querySelector(".pcoded-navbar").classList.remove("navbar-dark");
      document.querySelector(".pcoded-navbar").classList.remove("brand-dark");
      document.querySelector("body").classList.remove("datta-dark");
      this.setHeaderBackground("header-default");

      this.layoutType = layout;
      if (layout === "menu-light") {
        this.setNavbarBackground(this.navbarBackgroundColor);
        this.setBrandBackground(this.brandBackgroundColor);
        document.querySelector(".pcoded-navbar").classList.add(layout);
      }
      if (layout === "dark") {
        document.querySelector(".pcoded-navbar").classList.add("navbar-dark");
        document.querySelector(".pcoded-navbar").classList.add("brand-dark");

        this.setNavbarBackground("navbar-dark");
        this.setBrandBackground("brand-dark");

        if (this.dattaConfig["pre-layout"] !== "layout-6") {
          this.setHeaderBackground("header-dark");
        }

        document.querySelector("body").classList.add("datta-dark");
      }
      if (layout === "reset") {
        this.reset();
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setLayout :" + ex.message);
    }
  }

  reset() {
    try {
      document.querySelector(".pcoded-navbar").classList.remove("icon-colored");
      this.ngOnInit();
    } catch (ex) {
      this.skyAcceAp.LogEx("config, reset :" + ex.message);
    }
  }

  setColoredIcon(e) {
    try {
      const flag = !!e.target.checked;
      this.changeIconColor(flag);
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setColoredIcon :" + ex.message);
    }
  }

  changeIconColor(flag) {
    try {
      if (flag) {
        document.querySelector(".pcoded-navbar").classList.add("icon-colored");
      } else {
        document
          .querySelector(".pcoded-navbar")
          .classList.remove("icon-colored");
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, changeIconColor :" + ex.message);
    }
  }

  setRtlLayout(e) {
    try {
      const flag = !!e.target.checked;
      this.changeRtlLayout(flag);
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setRtlLayout :" + ex.message);
    }
  }

  changeRtlLayout(flag) {
    try {
      if (flag) {
        document.querySelector("body").classList.add("datta-rtl");
      } else {
        document.querySelector("body").classList.remove("datta-rtl");
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, changeRtlLayout :" + ex.message);
    }
  }

  setMenuFixedLayout(e) {
    try {
      const flag = !!e.target.checked;
      this.changeMenuFixedLayout(flag);
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setMenuFixedLayout :" + ex.message);
    }
  }

  changeMenuFixedLayout(flag) {
    setTimeout(() => {
      try {
        if (flag) {
          document
            .querySelector(".pcoded-navbar")
            .classList.remove("menupos-static");
          //(document.querySelector('#nav-ps-datta') as HTMLElement).style.maxHeight = 'calc(100vh - 70px)';
          (document.querySelector(
            "#nav-ps-datta"
          ) as HTMLElement).style.maxHeight = "100%";
        } else {
          document
            .querySelector(".pcoded-navbar")
            .classList.add("menupos-static");
          (document.querySelector(
            "#nav-ps-datta"
          ) as HTMLElement).style.maxHeight = "100%";
        }
      } catch (ex) {
        this.skyAcceAp.LogEx("config, changeMenuFixedLayout :" + ex.message);
      }
    }, 100);
  }

  setHeaderFixedLayout(e) {
    try {
      const flag = !!e.target.checked;
      this.changeHeaderFixedLayout(flag);
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setHeaderFixedLayout :" + ex.message);
    }
  }

  changeHeaderFixedLayout(flag) {
    try {
      if (flag) {
        document
          .querySelector(".pcoded-header")
          .classList.add("headerpos-fixed");
        document.querySelector(".pcoded-header").classList.add("header-blue");
      } else {
        document
          .querySelector(".pcoded-header")
          .classList.remove("headerpos-fixed");
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, changeHeaderFixedLayout :" + ex.message);
    }
  }

  setBoxLayout(e) {
    try {
      const flag = !!e.target.checked;
      this.changeBoxLayout(flag);
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setBoxLayout :" + ex.message);
    }
  }

  changeBoxLayout(flag) {
    try {
      if (flag) {
        document.querySelector("body").classList.add("container");
        document.querySelector("body").classList.add("box-layout");
      } else {
        document.querySelector("body").classList.remove("box-layout");
        document.querySelector("body").classList.remove("container");
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, changeBoxLayout :" + ex.message);
    }
  }

  hideMenuTitle(e) {
    try {
      const flag = !!e.target.checked;
      this.changeMenuTitle(flag);
    } catch (ex) {
      this.skyAcceAp.LogEx("config, hideMenuTitle :" + ex.message);
    }
  }

  changeMenuTitle(flag) {
    try {
      if (flag) {
        document.querySelector(".pcoded-navbar").classList.add("caption-hide");
      } else {
        document
          .querySelector(".pcoded-navbar")
          .classList.remove("caption-hide");
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, changeMenuTitle :" + ex.message);
    }
  }

  setHeaderBackground(background) {
    try {
      this.headerBackgroundColor = background;
      document.querySelector(".pcoded-header").classList.remove("header-blue");
      document.querySelector(".pcoded-header").classList.remove("header-red");
      document
        .querySelector(".pcoded-header")
        .classList.remove("header-purple");
      document
        .querySelector(".pcoded-header")
        .classList.remove("header-lightblue");
      document.querySelector(".pcoded-header").classList.remove("header-dark");
      if (background !== "header-default") {
        document.querySelector(".pcoded-header").classList.add(background);
      }

      // document.querySelector('.pcoded-navbar').classList.add('header-dark');
      // (document.querySelector('.header-dark') as HTMLElement).style.background = '#f226ac';
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setHeaderBackground :" + ex.message);
    }
  }

  setNavbarBackground(background) {
    try {
      this.setBackgroundImage(this.dattaConfig["nav-back-image"]);
      this.navbarBackgroundColor = background;
      document.querySelector(".pcoded-navbar").classList.remove("navbar-blue");
      document.querySelector(".pcoded-navbar").classList.remove("navbar-red");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-purple");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-lightblue");
      document.querySelector(".pcoded-navbar").classList.remove("navbar-dark");

      // add default menu brand background color
      document.querySelector(".pcoded-navbar").classList.add("brand-default");
      if (background !== "navbar-default") {
        document.querySelector(".pcoded-navbar").classList.add(background);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setNavbarBackground :" + ex.message);
    }
  }

  setBrandBackground(background) {
    try {
      this.brandBackgroundColor = background;
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("brand-default");
      document.querySelector(".pcoded-navbar").classList.remove("brand-blue");
      document.querySelector(".pcoded-navbar").classList.remove("brand-red");
      document.querySelector(".pcoded-navbar").classList.remove("brand-purple");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("brand-lightblue");
      document.querySelector(".pcoded-navbar").classList.remove("brand-dark");
      document.querySelector(".pcoded-navbar").classList.add(background);

      // document.querySelector('.pcoded-navbar').classList.add('brand-default');
      // (document.querySelector('.brand-default .header-logo') as HTMLElement).style.background = '#f226ac';
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setBrandBackground :" + ex.message);
    }
  }

  setBackgroundImage(image) {
    try {
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-image-1");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-image-2");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-image-3");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-image-4");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("navbar-image-5");
      if (image) {
        this.navBackgorundImage = image;
        document.querySelector(".pcoded-navbar").classList.add(image);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setBackgroundImage :" + ex.message);
    }
  }

  setMenuDropdownIcon(icon) {
    try {
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("drp-icon-style1");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("drp-icon-style2");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("drp-icon-style3");
      if (icon !== "style1") {
        document
          .querySelector(".pcoded-navbar")
          .classList.add("drp-icon-" + icon);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setMenuDropdownIcon :" + ex.message);
    }
  }

  setMenuListIcon(icon) {
    try {
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("menu-item-icon-style1");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("menu-item-icon-style2");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("menu-item-icon-style3");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("menu-item-icon-style4");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("menu-item-icon-style5");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("menu-item-icon-style6");
      if (icon !== "style1") {
        document
          .querySelector(".pcoded-navbar")
          .classList.add("menu-item-icon-" + icon);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setMenuListIcon :" + ex.message);
    }
  }

  setNavActiveColor(style) {
    try {
      this.navActiveColor = style;
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("active-default");
      document.querySelector(".pcoded-navbar").classList.remove("active-blue");
      document.querySelector(".pcoded-navbar").classList.remove("active-red");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("active-purple");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("active-lightblue");
      document.querySelector(".pcoded-navbar").classList.remove("active-dark");
      if (style !== "active-default") {
        document.querySelector(".pcoded-navbar").classList.add(style);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setNavActiveColor :" + ex.message);
    }
  }

  setNavTitleColor(style) {
    try {
      this.navTitleColor = style;
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("title-default");
      document.querySelector(".pcoded-navbar").classList.remove("title-blue");
      document.querySelector(".pcoded-navbar").classList.remove("title-red");
      document.querySelector(".pcoded-navbar").classList.remove("title-purple");
      document
        .querySelector(".pcoded-navbar")
        .classList.remove("title-lightblue");
      document.querySelector(".pcoded-navbar").classList.remove("title-dark");
      if (style !== "title-default") {
        document.querySelector(".pcoded-navbar").classList.add(style);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, setNavTitleColor :" + ex.message);
    }
  }

  SetNavBrandBreadColor(ColorClass: string): void {
    try {
      document
        .querySelector(".ColorChangedOvrBck")
        .classList.remove("ColorBlack");
      document
        .querySelector(".ColorChangedOvrBck")
        .classList.remove("ColorWhite");
      if (ColorClass) {
        document.querySelector(".ColorChangedOvrBck").classList.add(ColorClass);
      }
    } catch (ex) {
      this.skyAcceAp.LogEx("config, SetNavBrandBreadColor :" + ex.message);
    }
  }
}
